export function NoiseOverlay() {
  return (
    <div
      aria-hidden="true"
      className="bg-noise pointer-events-none fixed inset-0 z-[1] opacity-[0.035] mix-blend-overlay"
    />
  );
}
